import React from 'react';

const Pagination = ({ 
  currentPage, 
  totalPages, 
  itemsPerPage, 
  totalItems,
  indexOfFirstItem,
  indexOfLastItem,
  onPageChange 
}) => {
  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }
  
  const nextPage = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };
  
  const prevPage = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };
  
  const paginate = (pageNumber) => onPageChange(pageNumber);

  return (
    <div className="mt-4 flex flex-col space-y-2 md:flex-row md:items-center md:justify-between md:space-y-0">
      <div className="text-sm text-slate-600">
        Mostrando <span className="font-semibold text-slate-900">{indexOfFirstItem + 1}</span> a{' '}
        <span className="font-semibold text-slate-900">{Math.min(indexOfLastItem, totalItems)}</span> de{' '}
        <span className="font-semibold text-slate-900">{totalItems}</span> resultados
      </div>
      
      <div className="flex flex-wrap gap-1">
        <button
          onClick={prevPage}
          disabled={currentPage === 1}
          className={`px-3 py-1 rounded-md ${
            currentPage === 1 
              ? 'cursor-not-allowed bg-slate-100 text-slate-400'
              : 'bg-slate-200 text-slate-700 hover:bg-slate-300'
          }`}
        >
          Anterior
        </button>
        
        {pageNumbers.map(number => (
          <button
            key={number}
            onClick={() => paginate(number)}
            className={`px-3 py-1 rounded-md ${
              currentPage === number
                ? 'bg-red-600 text-white'
                : 'bg-slate-200 text-slate-700 hover:bg-slate-300'
            }`}
          >
            {number}
          </button>
        ))}
        
        <button
          onClick={nextPage}
          disabled={currentPage === totalPages}
          className={`px-3 py-1 rounded-md ${
            currentPage === totalPages 
              ? 'cursor-not-allowed bg-slate-100 text-slate-400'
              : 'bg-slate-200 text-slate-700 hover:bg-slate-300'
          }`}
        >
          Siguiente
        </button>
      </div>
    </div>
  );
};

export default Pagination;
